/**
 * 目的: APIから返る「派生画像URL」を安全に選択し、next/image の最適化有無も判断する
 *
 * 方針:
 * - サーバ側（CloudFront/S3）で最適化済みの派生画像を優先して使う
 * - 未対応環境/旧APIでも動くよう、常にフォールバックを持つ
 */

export type DerivedImageUrls = {
  original?: string | null;
  card16x9?: string | null;
  hero16x9?: string | null;
};

export type ImageVariant = keyof DerivedImageUrls;

/**
 * 目的: 派生URLを優先して画像URLを決定する
 * 引数:
 * - urls: APIの *Urls（存在しない場合あり）
 * - fallback: 旧フィールド（imageUrl/coverImage/photoUrl）など
 * - variant: 使いたい用途（card16x9/hero16x9/original）
 * 戻り値: string | null
 */
export function pickImageUrl(
  urls: DerivedImageUrls | null | undefined,
  fallback: string | null | undefined,
  variant: ImageVariant
): string | null {
  const fromUrls = (urls?.[variant] ?? null) || null;
  if (fromUrls) return fromUrls;
  const original = (urls?.original ?? null) || null;
  if (original) return original;
  return fallback ?? null;
}

/**
 * 目的: next/image のプロキシ最適化を避けるべきか判定する
 * - リモート（http/https）の場合は unoptimized を true にする（/ _next/image を経由しない）
 */
export function shouldUnoptimizeImage(src: string | null | undefined): boolean {
  if (!src) return false;
  return /^https?:\/\//i.test(src);
}

